import React, { useState, useEffect, useContext } from "react";
import { Card, Row, Col, Button, Image, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import avatar from "../image/avatar.png";
import NavSearch from "./NavSearch/NavSearch";
import ServiceMedecin from "./Services/ServicesSearch";
import "./UserDetails.css";
import { MedecinContext, VilleContext, SecteurContext } from "../../App";
import Pagination from "./Pagination";
import team from "../../image/team-3.jpg";
import ServiceAdmin from "../PageHomeAdmin/Services/ServiceAdmin";
const UserDetails = (props) => {
  const { listMedecin, setListMedecin } = useContext(MedecinContext);
  const { ville, setVille } = useContext(VilleContext);
  const { secteur, setSecteur } = useContext(SecteurContext);
  const [infoMedecin, setInfoMedecin] = useState([]);

  //pagination
  const [showPerPage, setShowPerPage] = useState(10);

  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });

  // const filterData = () => {
  //   const filtredData = infoMedecin;
  // };

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  useEffect(() => {
    GetMedecin();
  }, []);
  const GetMedecin = (e) => {
    ServiceMedecin.getMedecin().then((res) => {
      // console.log("infoMedecin", res.data);
      setInfoMedecin(res.data);
    });
  };

  const searchByInfo = (info, city, secteur) => {
    let resultInfo = [];
    let mixedResult = [];
    let result = [];
    // Search by info and city
    if (info && city) {
      if (searchByCity(city) && searchByInfo(info)) {
        searchByInfo(info).map((item, i) => {
          if (searchByCity(city)[0]) {
            if (item.city.name === searchByCity(city)[0].city.name) {
              mixedResult = [...mixedResult, item];
              result.push(...mixedResult);
            }
          }
        });
      } else {
        return false;
      }
    }
    // / Search by city and secteur
    else if (city && secteur) {
      if (searchBySecteur(secteur) && searchByCity(city)) {
        console.log("searchBySecteur(secteur)[0]", searchBySecteur(secteur)[0]);
        searchByCity(city).map((item, i) => {
          if (searchBySecteur(secteur)[0]) {
            if (
              item.secteur.name === searchBySecteur(secteur)[0].secteur.name
            ) {
              console.log("this is item xxxxxxx", item);
              mixedResult = [...mixedResult, item];
              result.push(...mixedResult);
            }
          }
        });
      } else {
        return false;
      }
    }
    // / Search by info and secteur
    else if (info && secteur) {
      if (searchBySecteur(secteur) && searchByInfo(info)) {
        searchByInfo(info).map((item, i) => {
          if (searchBySecteur(secteur)[0]) {
            if (
              item.secteur &&
              item.secteur.name === searchBySecteur(secteur)[0].secteur.name
            ) {
              mixedResult = [...mixedResult, item];
              result.push(...mixedResult);
            }
          }
        });
      } else {
        return false;
      }
    }
    /// Search by info
    else if (info) {
      infoMedecin.map((item, i) => {
        if (
          item.firstName
            .toLowerCase()
            .split(" ")[0]
            .includes(info.toLowerCase().split(" ")[0]) &&
          item.lastName
            .toLowerCase()
            .split(" ")[0]
            .includes(info.toLowerCase().split(" ")[1]) &&
          item.lastName
            .toLowerCase()
            .split(" ")[1]
            .includes(info.toLowerCase().split(" ")[2])
        ) {
          resultInfo = [...resultInfo, infoMedecin[i]];
          result.push(...resultInfo);
        }
        /// searech by firstName
        if (
          item.lastName
            .toLowerCase()
            .split(" ")[0]
            .includes(info.toLowerCase().split(" ")[0])
        ) {
          resultInfo = [...resultInfo, infoMedecin[i]];
          result.push(...resultInfo);
        }
        /// searech by lastname
        if (
          item.lastName.toLowerCase().split(" ")[1] &&
          item.lastName
            .split(" ")[1]
            .toLowerCase()
            .includes(info.toLowerCase().split(" ")[0])
        ) {
          resultInfo = [...resultInfo, infoMedecin[i]];
          result.push(...resultInfo);
        }
        /// searech by speciality
        if (
          item.speciality.designation
            .split(" ")[0]
            .toLowerCase()
            .includes(info.toLowerCase().split(" ")[0])
        ) {
          resultInfo = [...resultInfo, infoMedecin[i]];
          result.push(...resultInfo);
        }
      });
    }
    /// Search by city
    else if (city) {
      result = searchByCity(city);
    }
    /// Search by secteur
    else {
      result = infoMedecin;
    }
    return result;
  };

  const searchByCity = (city) => {
    let result = [];
    infoMedecin.map((item, i) => {
      Object.values(item).map((item) => {
        if (typeof item === "object" && Object.values(item).includes(city)) {
          return (result = [...result, infoMedecin[i]]);
        } else {
          return false;
        }
      });
    });
    return result;
  };

  const searchBySecteur = (secteur) => {
    let result = [];
    infoMedecin.map((item, i) => {
      // console.log("list secteur", typeof item === "object");
      if (
        typeof item.secteur === "object" &&
        Object.values(item.secteur).includes(secteur)
      ) {
        return (result = [...result, infoMedecin[i]]);
      } else {
        return false;
      }
    });
    return result;
  };
  // console.log(searchByInfo(listMedecin.split(" ")[0], ville.name));
  // console.log("searchBySecteur", searchBySecteur(ville.designation));
  // console.log("Name", listMedecin.split(" ")[0]);
  // console.log(secteur.designation);
  console.log("this is secteur context", secteur, ville, listMedecin);
  const data = searchByInfo(
    listMedecin,
    ville.designation,
    secteur.designation
  );

  return (
    <>
      <div>
        <NavSearch />
        <Container>
          <div class="section-title">
            <h2>Medecin</h2>
          </div>
          <Row>
            {data &&
              data
                .slice(pagination.start, pagination.end)
                .map((medecin, index) => {
                  // console.log(medecin.secteur);
                  // console.log(JSON.parse(medecin.details).sociaux.facebook);
                  return (
                    // <Card className="container userdetails mb-3">
                    //   <Card.Body>
                    //     <Row>
                    //       <Col lg={3}>
                    //         <Image
                    //           src={avatar}
                    //           width="25%"
                    //           className="m-auto d-block"
                    //           roundedCircle
                    //         />
                    //         <h6 className="text-center mt-2">{`${medecin.firstName} ${medecin.lastName}`}</h6>
                    //         <p className="text-center">{`${
                    //           medecin.speciality
                    //             ? medecin.speciality.designation
                    //             : "Laboratoire"
                    //         }`}</p>
                    //       </Col>
                    //       <Col lg={3}>
                    //         <h6 className="mt-4">
                    //           <i
                    //             className="fas fa-map-marker-alt"
                    //             style={{ color: "rgba(67,95,113,0.3)" }}
                    //           ></i>
                    //           Adress :
                    //         </h6>
                    //         <Card.Text className="text">
                    //           {`${medecin.adresse} -${medecin.city.name}-`}
                    //         </Card.Text>
                    //       </Col>
                    //       <Col lg={3}>
                    //         <h6 className="mt-4">
                    //           <i
                    //             className="fas fa-phone-volume"
                    //             style={{ color: "rgba(67,95,113,0.3)" }}
                    //           ></i>{" "}
                    //           Telephone :
                    //         </h6>
                    //         <Card.Text className="text">{medecin.tel}</Card.Text>
                    //       </Col>
                    //       <Col lg={3}>
                    //         <div className="d-flex mt-4 profilBtn">
                    //           <Link to="/profile">
                    //             <Button
                    //               className="m-auto "
                    //               variant="primary"
                    //               onClick={() => {
                    //                 sessionStorage.setItem(
                    //                   "healthId",
                    //                   JSON.stringify(medecin)
                    //                 );
                    //                 sessionStorage.setItem(
                    //                   "dataCabinet",
                    //                   JSON.stringify(
                    //                     medecin.laboratory ? medecin.laboratory : {}
                    //                   )
                    //                 );
                    //               }}
                    //             >
                    //               <i
                    //                 className="fas fa-calendar-check mr-2"
                    //                 style={{
                    //                   color: "white",
                    //                   backgroundColor: "#0596de",
                    //                 }}
                    //               ></i>
                    //               Profile
                    //             </Button>
                    //           </Link>
                    //         </div>
                    //       </Col>
                    //     </Row>
                    //   </Card.Body>
                    // </Card>

                    <>
                      <Col md={6} key={index}>
                        <section id="team" class="team section-bg">
                          <div class="container" data-aos="fade-up">
                            <div
                              class="member d-flex align-items-start"
                              data-aos="zoom-in"
                              data-aos-delay="100"
                            >
                              <div class="pic">
                                <img src={team} class="img-fluid" alt="" />
                              </div>
                              <div class="member-info">
                                <h4>{`${medecin.firstName} ${medecin.lastName}`}</h4>
                                <span>{`${
                                  medecin.speciality
                                    ? medecin.speciality.designation
                                    : "Laboratoire"
                                }`}</span>

                                <p>{`${medecin.adresse} -${medecin.city.name}-${
                                  medecin.secteur && medecin.secteur.name
                                }`}</p>
                                <div class="social">
                                  <a href="">
                                    <i class=" fa fa-facebook"></i>
                                  </a>
                                  <a href="">
                                    <i class=" fa fa-instagram"></i>
                                  </a>
                                  <a href="">
                                    {" "}
                                    <i class=" fa fa-linkedin"></i>{" "}
                                  </a>
                                </div>
                                <div>
                                  <Link
                                    className="get-started-link "
                                    to="/profile"
                                  >
                                    <button
                                      className="m-auto get-started-btn "
                                      // variant="primary"
                                      onClick={() => {
                                        sessionStorage.setItem(
                                          "healthId",
                                          JSON.stringify(medecin)
                                        );
                                        sessionStorage.setItem(
                                          "dataCabinet",
                                          JSON.stringify(
                                            medecin.laboratory
                                              ? medecin.laboratory
                                              : {}
                                          )
                                        );
                                      }}
                                    >
                                      <i
                                        className="fas fa-calendar-check mr-2"
                                        style={{
                                          color: "white",
                                          backgroundColor: "#0596de",
                                        }}
                                      ></i>
                                      Profile
                                    </button>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </Col>
                    </>
                  );
                })}
          </Row>

          {data.length > 10 && (
            <Pagination
              showPerPage={showPerPage}
              onPaginationChange={onPaginationChange}
              total={data.length}
            />
          )}
        </Container>
      </div>
    </>
  );
};

export default UserDetails;
